<template>
  <v-app style="background: #f7f7f7">

    <v-navigation-drawer width="250" color="blue-darken-4" permanent>

      <div class="text-left ma-3">
        <Link :href="homeRoute" style="color: inherit; text-decoration: none">
          <h3 style="font-size: 20px; line-height: 1.2;">Uniform Smart City Evaluation (USE)</h3>
        </Link>

        <img
            alt="CPERI"
            src="@assets/images/logos/cperi-certh-logo-en-negative.webp"
            class="mt-3"
            style="height: 80px"/>
      </div>

      <v-divider class="mx-3 my-5" />

      <v-list style="font-size: 1rem">

        <v-list-item @click="() => visitPage($routes.root())" color="primary">
            <i class="fa fa-home" /> Home
        </v-list-item>

        <v-list-item @click="() => loggedInUser ? visitPage($routes.projects()) : {}" color="primary" :class="{ 'text-grey-lighten-1': !loggedInUser }">
          <i class="fa fa-book" /> Projects
        </v-list-item>

        <v-list-item @click="() => visitPage($routes.user_manual())" color="primary">
          <i class="fa fa-book-open" /> User Manual
        </v-list-item>

        <v-divider class="mx-3 my-5"></v-divider>

        <v-dialog v-model="dialog_kpi" persistent width="500" :disabled="!loggedInUser">
          <template v-slot:activator="{ props }">
            <v-list-item color="primary" v-bind="props" :class="{ 'text-grey-lighten-1': !loggedInUser }">
              <i class="fa fa-plus-circle" style="font-size:22px" /> Upload Custom KPI
            </v-list-item>
          </template>
          <v-card>
            <v-card-title><b>Upload Custom KPIs </b></v-card-title>
            <v-divider />
            <v-card-text>
              Import your custom KPI. A template can be found below.
              <b>Save your file as CSV with comma delimiter.</b>
              <v-spacer />
              <v-btn
                class="mt-5 mb-3"
                prepend-icon="fas fa-download"
                variant="outlined"
                :href="$routes.download_kpi_template()"
                download
                text="KPIS TEMPLATE"
              />
              <v-spacer />
              <v-file-input
                show-size
                rounded
                variant="outlined"
                label="CSV file"
                @input="form.uploaded_csv_file = $event.target.files[0]"
                accept=".csv"
                required
                class="mt-3"
              />

              <div class="w-100 text-left d-flex">
                <div style="width: 40px; display: inline-block" class="pt-3 d-block text-grey-darken-3">
                  <v-tooltip>
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" class="mr-3" size="x-small" icon variant="outlined">
                        <v-icon icon="fas fa-info" />
                      </v-btn>
                    </template>
                    <div style="max-width: 200px; white-space: normal">
                      After you upload the file, it will be inserted in USE as a "list", which can
                      be later loaded into one or more projects. Provide a descriptive name for the
                      stored list.
                    </div>
                  </v-tooltip>
                </div>
                <div class="w-100">
                  <v-text-field
                      label="KPIs list name"
                      hint="Enter a name..."
                      rounded
                      variant="outlined"
                      v-model="form.list_name"
                      :rules="listNameInputRules"
                  />
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="red-darken-3"
                rounded
                text="close"
                class="px-5"
                variant="text"
                @click="dialog_kpi = false"
              />

              <v-btn
                type="submit"
                color="blue-darken-4"
                prepend-icon="fas fa-check mr-2"
                class="px-5"
                rounded
                text="Submit"
                variant="flat"
                @click="submit"
                :disabled="form.list_name.length === 0 || form.uploaded_csv_file === null"
              />
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_psi" persistent width="500" :disabled="!loggedInUser">
          <template v-slot:activator="{ props }">
            <v-list-item color="primary" v-bind="props" :class="{ 'text-grey-lighten-1': !loggedInUser }">
              <i class="fa fa-plus-circle" style="font-size:22px" /> Upload Custom PSI
            </v-list-item>
          </template>
          <v-card>
            <v-card-title><b>Upload custom PSIs</b></v-card-title>
            <v-divider />
            <v-card-text>
              Import your custom KPI. A template can be found below.
              <b>Save your file as CSV with comma delimiter.</b>
              <v-spacer />
              <v-btn
                class="mt-5 mb-3"
                prepend-icon="fas fa-download"
                variant="outlined"
                :href="$routes.download_psi_template()"
                download
                text="PSIS TEMPLATE"
              />
              <v-spacer></v-spacer>
              <v-file-input
                show-size
                rounded
                variant="outlined"
                label="CSV file"
                @input="form2.uploaded_csv_file = $event.target.files[0]"
                accept=".csv"
                required
                class="mt-3"
              />

              <div class="w-100 text-left d-flex">
                <div style="width: 40px; display: inline-block" class="pt-3 d-block text-grey-darken-3">
                  <v-tooltip>
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" class="mr-3" size="x-small" icon variant="outlined">
                        <v-icon icon="fas fa-info" />
                      </v-btn>
                    </template>
                    <div style="max-width: 200px; white-space: normal">
                      After you upload the file, it will be inserted in USE as a "list", which can
                      be later loaded into one or more projects. Provide a descriptive name for the
                      stored list.
                    </div>
                  </v-tooltip>
                </div>
                <div class="w-100">
                  <v-text-field
                      label="PSIs list name"
                      rounded
                      variant="outlined"
                      v-model="form2.list_name"
                      :rules="listNameInputRules"
                      hint="Enter a name..."
                  />
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red-darken-3"
                rounded
                text="close"
                class="px-5"
                variant="text"
                @click="dialog_psi = false"
              />

              <v-btn
                type="submit"
                color="blue-darken-4"
                prepend-icon="fas fa-check mr-2"
                text="Submit"
                variant="flat"
                class="px-5"
                rounded
                @click="submit_psi"
                :disabled="form2.list_name.length === 0 || form2.uploaded_csv_file === null"
              />
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-divider class="mx-3 my-5"></v-divider>

        <v-list-item @click="() => visitPage($routes.kpi_types())">KPIs List</v-list-item>
        <v-list-item @click="() => visitPage($routes.psi_types())">PSIs List</v-list-item>


        <div v-if="loggedInUser">
          <v-divider class="mx-3 my-5"></v-divider>

          <Link
              :href="$routes.destroy_user_session()"
              text="Logout"
              type="button" class="btn v-btn bg-grey-lighten-4 pa-3 ml-3"
              method="delete">
          </Link>
          <br>
          <v-label class="mx-3 mt-3" id="email-label">{{ userEmail }}</v-label>
        </div>


      </v-list>
      <div v-if="loggedInUser && userEmail.includes('response')" class="bg-white rounded-lg ma-2 text-center">
        <img
          src="@assets/images/logos/response.png"
          alt="response-logo"
          class="ml-3"
          style="width: 200px"
        />
      </div>
    </v-navigation-drawer>

    <v-main class="main-content" style="padding: 5px">
      <Notifier />
      <slot />
    </v-main>
  </v-app>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";
import {computed, ref, inject, watch } from "vue";
import { router, useForm, usePage } from "@inertiajs/vue3";
import * as $routes from "@/packs/routes";
import Notifier from "@/Shared/Notifier.vue";

const page = usePage();
const notifier = inject('notifier');

// Global success/info notifier based on Inertia props
watch(
  () => page.props.notice,
  (val) => {
    if (val) {
      const type = page.props.noticeType || 'success';
      notifier?.show({ text: val, type, duration: 2000 });
    }
  },
  { immediate: true }
);

const homeRoute = computed(() => {
  return loggedInUser.value ? $routes.projects() : '/'
})

const loggedInUser = computed(() => {
  return page.props.auth.user !== null
})

const userEmail = computed(() => {
  return page.props.auth.user.email
})

const dialog_kpi = ref(false);
const dialog_psi = ref(false);

const listNameInputRules = [
  value => !!value || 'Required.',
  value => (value && value.length >= 3) || 'Min 3 characters',
]

const form = useForm({
  uploaded_csv_file: null,
  list_name: ''
});

const form2 = useForm({
  uploaded_csv_file: null,
  list_name: ''
});

const submit = () => {
  form.post($routes.import_csv_path());
  dialog_kpi.value = false;
};
const submit_psi = () => {
  form2.post($routes.import_psi_csv_path());
  dialog_psi.value = false;
};

function visitPage(route) {
  router.visit(route, { method: "get" });
}

</script>

<style lang="css" scoped>
.main-content {
  padding: 10px;
  margin-left: 280px;
  max-height: 100%;
  margin-bottom: 50px;
  margin-top: 30px;
}
</style>
